import { Hardware } from './codes';

export function startClock(send: (code: number) => void): () => void {
  const timer = window.setInterval(() => send(Hardware.CLOCK_PULSE), 50);
  return () => window.clearInterval(timer);
}

